import aiServer from '@assets/images/solution/recommendation/mobile/aiServer.avif';
import co2 from '@assets/images/solution/recommendation/mobile/co2.avif';
import edgeRtls from '@assets/images/solution/recommendation/mobile/edgeRtls.avif';
import fisheye from '@assets/images/solution/recommendation/mobile/fisheye.avif';
import idCard from '@assets/images/solution/recommendation/mobile/idCard.avif';
import ipCamera from '@assets/images/solution/recommendation/mobile/ipCamera.avif';
import loraGateway from '@assets/images/solution/recommendation/mobile/loraGateway.avif';
import nvr from '@assets/images/solution/recommendation/mobile/nvr.avif';
import patientTag from '@assets/images/solution/recommendation/mobile/patientTag.avif';
import ptz from '@assets/images/solution/recommendation/mobile/ptz.avif';
import safeCradle from '@assets/images/solution/recommendation/mobile/safeCradle.avif';
import safeTag from '@assets/images/solution/recommendation/mobile/safeTag.avif';
import safetyBell from '@assets/images/solution/recommendation/mobile/safetyBell.avif';
import server from '@assets/images/solution/recommendation/mobile/server.avif';
import slimTag from '@assets/images/solution/recommendation/mobile/slimTag.avif';
import stickerTag from '@assets/images/solution/recommendation/mobile/stickerTag.avif';
import switchImg from '@assets/images/solution/recommendation/mobile/switch.avif';
import twintrackerUwb from '@assets/images/solution/recommendation/mobile/twintrackerUwb.avif';
import uwbTag from '@assets/images/solution/recommendation/mobile/uwbTag.avif';
import plutoconPro from '@assets/images/solution/recommendation/mobile/plutoconPro.avif';
import twintrackerBLE from '@assets/images/solution/recommendation/mobile/twintrackerBle.avif';

export default {
  ipCamera: {
    title: 'Camera IP',
    desc: 'Camera IP là camera giám sát kỹ thuật số truyền dữ liệu hình ảnh qua mạng dựa trên giao thức Internet. Dễ lắp đặt, hỗ trợ giám sát từ xa và lưu trữ video, thường được sử dụng trong an ninh, an toàn và quản lý vận hành.',
    img: ipCamera,
    link: '/camera/edge',
  },
  ptzCamera: {
    title: 'Camera PTZ',
    desc: 'Camera PTZ là thiết bị giám sát hiệu suất cao có thể điều khiển từ xa với các chức năng xoay ngang (Pan), nghiêng dọc (Tilt), và thu phóng quang học (Zoom), giúp giám sát hiệu quả các khu vực rộng chỉ bằng một thiết bị.',
    img: ptz,
    link: '/camera/edge',
  },
  fisheyeCamera: {
    title: 'Camera Fisheye',
    desc: 'Camera Fisheye sử dụng ống kính góc siêu rộng trên 180 độ để bao quát toàn bộ không gian với một thiết bị duy nhất. Dù có hiện tượng méo hình, nhưng đảm bảo giám sát toàn cảnh không điểm mù.',
    img: fisheye,
    link: '/camera/edge',
  },
  co2: {
    title: 'Cảm biến CO₂',
    desc: 'Cảm biến CO₂ đo nồng độ khí CO₂ trong không khí theo thời gian thực. Khi vượt ngưỡng nguy hiểm, thiết bị sẽ phát cảnh báo âm thanh và hiển thị cảnh báo trực quan, hỗ trợ đảm bảo an toàn tại hiện trường.',
    img: co2,
    link: '/iot/co2',
  },
  server: {
    title: 'Máy chủ ORBRO',
    desc: 'Máy chủ ORBRO là nền tảng trung tâm tích hợp dữ liệu từ RTLS, camera, cảm biến và các thiết bị hiện trường khác. Hỗ trợ phân tích, báo cáo, cảnh báo theo thời gian thực và kết nối API với hệ thống doanh nghiệp.',
    img: server,
    link: '/os/server',
  },
  aiServer: {
    title: 'Máy chủ ORBRO AI',
    desc: 'Máy chủ ORBRO AI phân tích dữ liệu video và cảm biến theo thời gian thực ngay tại hiện trường, tự động phát hiện bất thường và gửi cảnh báo tức thì mà không cần phụ thuộc vào mạng, là máy chủ AI biên thông minh.',
    img: aiServer,
    link: '/camera/server',
  },
  nvr: {
    title: 'NVR',
    desc: 'NVR (Network Video Recorder) là thiết bị nhận, lưu trữ và quản lý hình ảnh từ camera qua mạng. Hỗ trợ ghi hình nhiều camera cùng lúc, giám sát thời gian thực và tìm kiếm video hiệu quả.',
    img: nvr,
    link: '/camera/server',
  },
  twintrackerUWB: {
    title: 'TwinTracker UWB',
    desc: 'TwinTracker UWB là thiết bị đọc tín hiệu định vị sử dụng băng tần siêu rộng (UWB), cung cấp vị trí chính xác ±10cm, theo dõi nhiều thẻ cùng lúc và duy trì dữ liệu vị trí ổn định trong môi trường phức tạp.',
    img: twintrackerUwb,
    link: '/rtls/uwb',
  },
  twintrackerBLE: {
    title: 'TwinTracker BLE',
    desc: 'TwinTracker BLE là thiết bị đọc định vị trong nhà sử dụng tín hiệu Bluetooth năng lượng thấp, theo dõi vị trí thẻ theo vùng, dễ lắp đặt và phù hợp để quản lý số lượng lớn người hoặc tài sản.',
    img: twintrackerBLE,
    link: '/rtls/uwb',
  },
  uwbTag: {
    title: 'Thẻ UWB',
    desc: 'Thẻ UWB được gắn lên người hoặc thiết bị để theo dõi vị trí theo thời gian thực với độ chính xác ±10cm. Thiết kế chống va đập, chống nước và tiết kiệm điện giúp sử dụng lâu dài.',
    img: uwbTag,
    link: '/rtls/uwb',
  },
  stickerTag: {
    title: 'Sticker Tag',
    desc: 'Sticker Tag là thẻ siêu nhỏ dễ dàng dán lên tài sản, hỗ trợ theo dõi vị trí và lịch sử di chuyển theo thời gian thực. Nhẹ, tiết kiệm điện và phù hợp với môi trường logistics, sản xuất.',
    img: stickerTag,
    link: '/rtls/uwb',
  },
  slimTag: {
    title: 'Slim Tag',
    desc: 'Slim Tag là thẻ định vị siêu mỏng dạng thẻ dựa trên BLE, dễ dàng gắn vào túi áo đồng phục hoặc dán lên bề mặt tài sản, lý tưởng cho việc theo dõi người và thiết bị trong nhà.',
    img: slimTag,
    link: '/rtls/uwb',
  },
  edgeRtls: {
    title: 'ORBRO Edge RTLS',
    desc: 'ORBRO Edge RTLS xử lý tín hiệu từ thẻ tại hiện trường để tính toán vị trí theo thời gian thực. Là thiết bị biên có độ trễ cực thấp và hoạt động độc lập không cần đám mây.',
    img: edgeRtls,
    link: '/os/rtls',
  },
  edgeAi: {
    title: 'ORBRO Edge AI',
    desc: 'ORBRO Edge AI xử lý tín hiệu thẻ theo thời gian thực ngay tại hiện trường, cung cấp dữ liệu vị trí nhanh chóng, hoạt động độc lập không cần kết nối đám mây.',
    img: edgeRtls,
    link: '/os/rtls',
  },
  switch: {
    title: 'Switch PoE L2',
    desc: 'Switch PoE L2 cung cấp điện và truyền dữ liệu qua cùng một dây mạng, giúp kết nối hiệu quả các thiết bị hiện trường như camera, anchor UWB, reader BLE, tối ưu hệ thống mạng và tiết kiệm dây cáp.',
    img: switchImg,
    link: '/os/switch',
  },
  plutoconPro: {
    title: 'Plutocon Pro',
    desc: 'Plutocon Pro là beacon công nghiệp dựa trên BLE, có khả năng phát tín hiệu mạnh và ổn định trong phạm vi rộng. Thiết kế chống nước, chống bụi và thay pin dễ dàng, phù hợp cho logistics, sản xuất và quản lý tài sản.',
    img: plutoconPro,
    link: '/rtls/ble',
  },
  safeTag: {
    title: 'Safe Tag',
    desc: 'Safe Tag được gắn lên điện thoại hoặc thiết bị trưng bày, phát hiện và cảnh báo ngay khi có hiện tượng tháo rời, rung lắc hoặc rời khỏi vị trí — là thẻ bảo mật chuyên dụng.',
    img: safeTag,
    link: '/os/rtls',
  },
  safetyBell: {
    title: 'Safety Bell',
    desc: 'Safety Bell là thiết bị hỗ trợ an toàn phát tín hiệu cảnh báo ngay khi có tình huống khẩn cấp. Kết nối không dây với hệ thống để tăng tốc độ phản ứng toàn diện trong khu vực.',
    img: safetyBell,
    link: '/os/rtls',
  },
  safeCradle: {
    title: 'Safe Cradle',
    desc: 'Safe Cradle là giá đỡ chuyên dụng để cố định Safe Tag và thiết bị trưng bày, hỗ trợ cấp nguồn, truyền tín hiệu và phát hiện sự cố. Có thiết kế chống tháo rời và góc đặt chuẩn, giúp gửi cảnh báo ngay khi phát hiện bất thường.',
    img: safeCradle,
    link: '/os/rtls',
  },
  loraGateway: {
    title: 'Cổng LoRa',
    desc: 'Cổng LoRa là thiết bị trung tâm sử dụng giao thức LoRaWAN, thu thập dữ liệu từ cảm biến hoặc thẻ ở khoảng cách xa và truyền về máy chủ biên hoặc đám mây một cách ổn định.',
    img: loraGateway,
    link: '/os/rtls',
  },
  patientTag: {
    title: 'Thẻ bệnh nhân',
    desc: 'Thẻ bệnh nhân được đeo an toàn trong môi trường bệnh viện, theo dõi vị trí theo thời gian thực và gửi cảnh báo tự động khi rời khỏi khu vực chỉ định hoặc gặp sự cố, giúp xử lý khẩn cấp nhanh chóng.',
    img: patientTag,
    link: '/rtls/ble',
  },
  idCard: {
    title: 'Thẻ nhân viên',
    desc: 'Thẻ nhân viên giúp xác thực danh tính và kiểm soát ra vào. Được làm từ nhựa bền và tích hợp chip BLE, hỗ trợ xác minh không tiếp xúc, nhanh chóng và an toàn.',
    img: idCard,
    link: '/rtls/ble',
  },
};
